<app-patient-list [isSlimTable]="true"></app-patient-list>
